import { useCallback, useState } from 'react';

import { useUserData } from 'core/Api';
import { ConsumerCartItem, useResendCartReceipt } from 'store/Api';
import { ButtonMantine, Group, Modal, Stack, Text, ThemeIcon, notifications } from 'ui';
import { IconCircleCheck } from 'ui/Icons';

import classes from '../PurchaseDetailPage.module.css';

const SendReceiptContent = ({
  cartItem,
  success,
  setSuccess,
  onClose,
}: {
  cartItem?: ConsumerCartItem;
  success: boolean;
  onClose: () => void;
  setSuccess: (boolean: boolean) => void;
}) => {
  const { mutate: sendReceipt, isPending: isLoading } = useResendCartReceipt();

  const { data: user } = useUserData();
  return success ? (
    <Stack gap="xl">
      <Stack gap="xs">
        <Text fz={24} fw={600}>
          Your receipt will be sent to your email shortly
        </Text>
        <Text fz={14} fw={400} c="gray">
          Please check your email in a few minutes to view your receipt.
        </Text>
      </Stack>

      <ButtonMantine onClick={() => onClose()}>Okay, thanks!</ButtonMantine>
    </Stack>
  ) : (
    <Stack gap="xl">
      <Stack gap="xs">
        <Text fz={14}>We will send the receipt to your email</Text>
        <Text fz={14} fw={500}>
          {user?.email}
        </Text>
      </Stack>

      <ButtonMantine
        loading={isLoading}
        onClick={() =>
          sendReceipt(
            { causeId: cartItem?.cart?.cause_id, cartId: cartItem?.cart?.uuid },
            {
              onSuccess: () => setSuccess(true),
              onError: () =>
                notifications.show({
                  message: 'Unable to send your receipt, please try again',
                  variant: 'error',
                }),
            }
          )
        }
      >
        Send
      </ButtonMantine>
    </Stack>
  );
};

const SendReceipt = ({
  opened,
  onClose,
  cartItem,
}: {
  opened: boolean;
  cartItem?: ConsumerCartItem;
  onClose: () => void;
}) => {
  const [success, setSuccess] = useState(false);

  const handleClose = useCallback(() => {
    setSuccess(false);
    onClose();
  }, [onClose]);

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={
        success ? (
          <Group justify="center" style={{ flexGrow: 1, marginLeft: 'auto', marginRight: 'auto' }}>
            <ThemeIcon color={'#68C097'} size={64}>
              <IconCircleCheck />
            </ThemeIcon>
          </Group>
        ) : (
          'Send to Receipt'
        )
      }
      classNames={{ title: classes.successModalHeader }}
    >
      <SendReceiptContent
        success={success}
        cartItem={cartItem}
        onClose={handleClose}
        setSuccess={setSuccess}
      />
    </Modal>
  );
};
export { SendReceipt };
